module.exports = __webpack_public_path__ + "img/destilado.abd3c7ca.jpg";